<template>
  <div>
    <TopBar pagetitle="参加抽奖活动" :back-url="backurl" />
    <div class="card"><img src="/img/adexCard.jpg"></div>
    <div class="selectRect">
      <div class="title">选择卡片信息</div>
      <div class="title2">鉴定卡</div>
      <div class="selectItems">
        <div v-for="item in RaffleReg" :key="item.text" :class="item.select?'select':''">
          <!-- <span :class="item.real?'realColor':'aboutStr'" @click="onSelect(item.value)" v-html="item.text" /> -->
          <span class="realColor" @click="onSelect(item.value)" v-html="item.text" />
        </div>
      </div>
      <div class="title2">地址</div>
      <div v-if="!addressID" class="addressRect" @click="onSelectAddress"><i class="iconfont iconadd" /></div>
      <div v-if="addressID" class="addressRectHave" @click="onSelectAddress" v-html="addressBody" />
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="info" :loading="buttonLoading" square @click="onGift" disbaled>提交认证审核，参与抽奖[已结束]</van-button>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import request from '@/utils/request'
import { getUrlKey, MyNotify } from '@/utils/base'
import { Button, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      backurl: '/activity/raffle',
      buttonLoading: false,
      RaffleReg: [],
      selectId: undefined,
      addressID: undefined,
      addressBody: undefined
    }
  },
  mounted() {
    console.log('进入')
    document.getElementsByTagName('body')[0].className = 'activeBacl'
  },
  destroyed: function() {
    console.log('离开')
    document.body.removeAttribute('class', 'activeBacl')
  },
  created() {
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    var addressId = getUrlKey('addressId')
    if (addressId !== null) {
      this.addressID = addressId
      this.getAddress(this.addressID)
    }
    this.getRaffleReg()
  },
  methods: {
    onTopBack() {
      this.$router.replace('/home/index')
    },
    onGift() {
      if (!this.addressID || this.addressID.length <= 0) {
        MyNotify('info', '请选择收件地址')
        return
      }
      if (!this.selectId || this.selectId.length <= 0) {
        MyNotify('info', '必须选择鉴定卡')
        return
      }
      this.buttonLoading = true
      request({
        url: '/Activity/addLuckDarwCard',
        method: 'post',
        data: {
          addressID: this.addressID,
          cardId: this.selectId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          MyNotify('success', '参加抽奖活动成功!祝您好运!')
          this.$router.replace('/activity/raffleList')
        } else {
          Dialog.confirm({
            title: '已经参加抽奖',
            message: '您已经成功参加抽奖活动，无法重复参加，是否查看中奖情况?'
          }).then(() => {
            this.$router.replace('/activity/raffleList')
          })
        }
      })
    },
    getAddress(id, callback) {
      request({
        url: '/Store/getUserAddress',
        method: 'post',
        params: { addressId: id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.addressBody = response.data.zipString + response.data.address + '<br>' +
            response.data.name + ' ' + response.data.phone
        if (callback) {
          callback()
        }
      })
    },
    getRaffleReg(callback) {
      request({
        url: '/Activity/getRaffleReg',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }

        this.RaffleReg = response.data
        this.RaffleReg.map((value, index, array) => {
          value.select = false
        })
        // this.RaffleReg = []
        if (this.RaffleReg.length === 0) {
          this.RaffleReg.push({
            text: '<i class="iconfont iconadd" /><br><span style="font-size:0.7em">交叉认证一张其他机构的卡<span>',
            real: true,
            value: 0
          })
        } else {
          var selectId = Cookies.get('raffleReg_Select')
          if (selectId) {
            this.selectId = selectId
            this.onSelect(selectId)
          }
        }
        if (callback) {
          callback()
        }
      })
    },
    onSelectAddress() {
      this.$router.replace('/store/addressList?type=raffleReg&backurl=/activity/raffleReg')
    },
    onSelect(id) {
      console.log(id)
      this.RaffleReg.map((value, index, array) => {
        if (value.value.toString() === id.toString()) {
          value.select = true
          if (value.value === 0) {
            this.$router.replace('/textbook/crossCertificationList?backurl=/activity/raffleReg')
          } else {
            this.selectId = value.value
            Cookies.set('raffleReg_Select', value.value)
          }
        } else {
          value.select = false
        }
      })
      this.RaffleReg = JSON.parse(JSON.stringify(this.RaffleReg))
    }
  }
}
</script>
<style scoped>
.topBack{
  position: absolute;
  left:1em;
  top: 1em;
  color: #fff;
}
.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}
.card{
    margin-top: 2em;
    padding: 0 2em;

}
.card img{
    width: 100%;
    border-radius: 0.5em;
}
.selectRect{
    padding:  2em 2em 0 2em;
    color: #fff;
}
.selectRect .title{
    padding: 0.5em 0;
    border-bottom: 1px solid #444;
}
.selectRect .title2{
    padding: 0.5em 0;
}
.selectItems{
}
.selectItems div{
    min-width: 5em;
    text-align: center;
    border: 1px solid #fff;
    color: #fff;
    padding: 0.3em;
    margin: 0.3em;
    background-color:transparent;
}
.selectItems .select{
    background-color:#1569E5 !important;
    border: 1px solid #1569E5 !important;
}

.addressRect{
    text-align: center;
    height: 4em;
    line-height: 4em;
     border: 1px solid #fff;
}
.addressRectHave{
    text-align: center;
    height: 4em;
     border: 1px solid #fff;
}
.downButton{
    position:fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
}
.downButton button{
    width: 100%;
    color: #fff;
    background-color:#1569E5 !important;
    border: 1px solid #1569E5 !important;
}
.emptyRect{
    height: 5em;
}
.realColor{
    color: #fff;
}
</style>
